import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ModalConfirmComponent } from '../../../../../components/modal-confirm/modal-confirm.component';
var ClientKindListComponent = /** @class */ (function () {
    function ClientKindListComponent(authService, snackBar, dialog) {
        this.authService = authService;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.headersTable = ['title', 'isDefault', 'actions'];
        this.kinds = [];
    }
    ClientKindListComponent.prototype.ngOnInit = function () {
        this.listAirports();
    };
    ClientKindListComponent.prototype.listAirports = function () {
        var _this = this;
        this.authService.clientKindList().then(function (response) {
            _this.kinds = response.results;
        }, function (error) {
            console.log(error);
            _this.snackBar.open(error.error.message);
        });
    };
    ClientKindListComponent.prototype.remove = function (id) {
        var _this = this;
        this.dialog
            .open(ModalConfirmComponent, {
            width: '500px',
            data: {
                text: 'Deseja remover essa Segmentação?',
                buttonConfirmText: 'Remover',
            },
        })
            .afterClosed()
            .toPromise()
            .then(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (result && result !== 'cancel') {
                    return [2 /*return*/, this.authService.clientKindDelete(id).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                this.listAirports();
                                this.snackBar.open('Segmentação removido com sucesso.');
                                return [2 /*return*/];
                            });
                        }); }, function (error) {
                            console.log(error);
                            _this.snackBar.open(error.error.message);
                        })];
                }
                return [2 /*return*/];
            });
        }); })
            .catch(function (err) {
            _this.snackBar.open(err.message);
        });
    };
    return ClientKindListComponent;
}());
export { ClientKindListComponent };
